export function generateUrlQueryString(list: { key: string; value: string }[]) {
  const queryList = list
    .filter((item) => !!item.key)
    .map((item) => `${encodeURIComponent(item.key)}=${encodeURIComponent(item.value || '')}`);

  return queryList.length ? `?${queryList.join('&')}` : '';
}
